<template>
  <div class="overflow-auto bg-n-surface-1 w-full px-6">
    <div class="mx-auto max-w-[1500px] pb-12">
      <router-view />
    </div>
  </div>
</template>
